import FuseUtils from '@fuse/utils';
import AppContext from 'app/AppContext';
import { Component } from 'react';
import { connect } from 'react-redux';
import { matchRoutes } from 'react-router-config';
import { withRouter } from 'react-router-dom';

const pickLanding = (userRole) => {
	const r = Array.isArray(userRole) ? userRole[0] : userRole;
	if (r === 'admin') return '/user';
	if (r === 'expert') return '/task-manager'; // írd át, ha mást szeretnél kezdőnek
	return '/what-if'; // operator default
};

class FuseAuthorization extends Component {
	constructor(props, context) {
		super(props);
		const { routes } = context;
		this.state = { accessGranted: true, routes };
	}

	componentDidMount() { this._update(); }

	shouldComponentUpdate(nextProps, nextState) {
		return nextProps.location.pathname !== this.props.location.pathname || nextState.accessGranted !== this.state.accessGranted || nextProps.userRole !== this.props.userRole;
	}

	componentDidUpdate() { this._update(); }

	static getDerivedStateFromProps(props, state) {
		const { location, userRole } = props;
		const { pathname } = location;

		const matchedArr = matchRoutes(state.routes, pathname);
		const matched = matchedArr && matchedArr.length ? matchedArr[0] : null;

		return { accessGranted: matched && matched.route && matched.route.auth ? FuseUtils.hasPermission(matched.route.auth, userRole) : true };
	}

	_update() {
		if (!this.state.accessGranted) this.redirectRoute();
	}

	redirectRoute() {
		const { location, userRole, history } = this.props;
		const { pathname, state } = location;

		const landing = pickLanding(userRole);
		const redirectUrl = state && state.redirectUrl ? state.redirectUrl : landing;

		// Guest -> Login + visszairányítás
		if (!userRole || userRole.length === 0) {
			history.push({ pathname: '/login', state: { redirectUrl: pathname } });
			return;
		}

		// Member -> ha van redirectUrl, próbáljuk; ha nincs jog, menjen landingre
		const matchedArr = matchRoutes(this.state.routes, redirectUrl);
		const matched = matchedArr && matchedArr.length ? matchedArr[0] : null;
		const accessGranted = matched && matched.route && matched.route.auth ? FuseUtils.hasPermission(matched.route.auth, userRole) : true;

		history.push({ pathname: accessGranted ? redirectUrl : landing });
	}

	render() {
		return this.state.accessGranted ? <>{this.props.children}</> : null;
	}
}

function mapStateToProps({ auth }) {
	return { userRole: auth.user.role };
}

FuseAuthorization.contextType = AppContext;

export default withRouter(connect(mapStateToProps)(FuseAuthorization));
